import { ReactLenis, useLenis } from "lenis/react";
import "lenis/dist/lenis.css";

/**
 * Site-wide inertia smoothing for wheel/trackpad scrolling (native touch scrolling is left
 * untouched on phones). Lenis respects prefers-reduced-motion automatically.
 */
const OPTIONS = {
  lerp: 0.09,
  duration: 1.1,
  smoothWheel: true,
  wheelMultiplier: 0.95,
  allowNestedScroll: true,
  anchors: { offset: -120 },
};

export const SmoothScroll = ({ children }) => (
  <ReactLenis root options={OPTIONS}>
    {children}
  </ReactLenis>
);

/** Programmatic scrolling that stays in sync with Lenis (falls back to the window API). */
export const useScrollTo = () => {
  const lenis = useLenis();
  return (target, { offset = 0, immediate = false } = {}) => {
    if (lenis) {
      lenis.scrollTo(target, { offset, immediate, duration: 1.1 });
      return;
    }
    if (typeof target === "number") {
      window.scrollTo({ top: target, behavior: immediate ? "instant" : "smooth" });
      return;
    }
    const top = target.getBoundingClientRect().top + window.scrollY + offset;
    window.scrollTo({ top, behavior: immediate ? "instant" : "smooth" });
  };
};
